import { tss } from 'tss-react/mui';

export const useStyles = tss.withName('ComponentsLogo').create(({ theme }) => ({
  root: {
    height: theme.typography.pxToRem(32),
    cursor: 'pointer'
  }
}));
